import { Component, Input, OnInit } from '@angular/core';
import { GridCell, SectionData } from '../../models/sections-model';
import { LocalDataSource } from 'angular2-smart-table';

@Component({
  selector: 'kw-cart-renderer',
  templateUrl: './cart-renderer.component.html',
  styleUrls: ['./cart-renderer.component.scss']
})
export class CartRendererComponent implements OnInit {
  @Input()data:SectionData;
  @Input() edit:boolean = true;
  @Input() title:string;

  gridCells:GridCell[];
  settings:any = {
    mode:'external',
    noDataMessage:"Your cart is empty. Continue shopping to add items to your cart",
    hideSubHeader: true,
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      product: {
        title: 'Product',
        width:'20%'
      },
      description: {
        title: 'Description',
        width:'30%'
      },
      username: {
        title: 'Quantity',
        width:'10%'
      },
      unitPrice: {
        title: 'Unit Price',
        width:'10%'
      },
      adjustments: {
        title: 'Adjustments',
        width:'10%'
      },
      itemTotal: {
        title: 'Item Total',
        width:'10%'
      }
    },
    pager:{
      perPage:50
    },
    actions:{
      position:"right",
      add:false
    }
  }

  source: LocalDataSource = new LocalDataSource();
  source2: LocalDataSource = new LocalDataSource();

  settings2:any = {
    mode:'external',
    hideSubHeader: true,
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      descritpion: {
        title: 'Description',
        width:'90%'
      },
      total: {
        title: 'Totals',
        width:'10%'
      }
    },
    actions:false
  }

  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
  }

}
